import { render, staticRenderFns } from "./MspAllenamentoItem.vue?vue&type=template&id=b59ec608"
import script from "./MspAllenamentoItem.vue?vue&type=script&lang=js"
export * from "./MspAllenamentoItem.vue?vue&type=script&lang=js"
import style0 from "./MspAllenamentoItem.vue?vue&type=style&index=0&id=b59ec608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports